"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _superagent = _interopRequireDefault(require("superagent"));
var _normalizeObject = _interopRequireDefault(require("normalize-object"));
var _lodash = require("lodash");
var _layouts = require("@seedlang/layouts");
var _server_store = _interopRequireDefault(require("./server_store"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1;
var LOG_REACT_NATIVE_REQUESTS = true;
var GENERIC_USER_ERROR_MESSAGE = 'Sorry, an error has occurred. Our developers have been notified. Please contact us at help@seedlang.com if you need any assistance.';
var SIMULATE_MOBILE_AUTH = false;
var Api = (_class = /*#__PURE__*/function () {
  function Api() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, Api);
    (0, _initializerDefineProperty2["default"])(this, "oustandingRequests", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "csrfToken", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "jwtToken", _descriptor3, this);
    (0, _initializerDefineProperty2["default"])(this, "mobileVersionNumber", _descriptor4, this);
    (0, _initializerDefineProperty2["default"])(this, "osVersion", _descriptor5, this);
    (0, _initializerDefineProperty2["default"])(this, "nativeDevice", _descriptor6, this);
    (0, _initializerDefineProperty2["default"])(this, "deviceLanguageId", _descriptor7, this);
    (0, _initializerDefineProperty2["default"])(this, "siteId", _descriptor8, this);
    (0, _initializerDefineProperty2["default"])(this, "appEnvironment", _descriptor9, this);
    (0, _initializerDefineProperty2["default"])(this, "isBrowser", _descriptor0, this);
    (0, _initializerDefineProperty2["default"])(this, "devApiPath", _descriptor1, this);
    this.setJwtToken = function (jwtToken) {
      _this.jwtToken = jwtToken;
    };
    this.setMobileVersionNumber = function (mobileVersionNumber) {
      _this.mobileVersionNumber = mobileVersionNumber;
    };
    this.setOsVersion = function (osVersion) {
      _this.osVersion = osVersion;
    };
    this.setNativeDevice = function (nativeDevice) {
      _this.nativeDevice = nativeDevice;
    };
    this.setDeviceLanguageId = function (deviceLanguageId) {
      _this.deviceLanguageId = deviceLanguageId;
    };
    this.setAppEnvironment = function (appEnvironment) {
      _this.appEnvironment = appEnvironment;
    };
    this.setSiteId = function (siteId) {
      _this.siteId = siteId;
    };
    this.setDevApiPath = function (devApiPath) {
      _this.devApiPath = devApiPath;
    };
  }
  return (0, _createClass2["default"])(Api, [{
    key: "getDeviceTimeZone",
    value: function getDeviceTimeZone() {
      try {
        return typeof Intl !== 'undefined' && Intl.DateTimeFormat && Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch (_unused) {
        return null;
      }
    }
  }, {
    key: "ajax",
    value: function ajax(params) {
      var _this2 = this;
      this.oustandingRequests += 1;
      this.layout = new _layouts.RootLayout();
      var requestFinalized = false;
      var finalizeRequest = function finalizeRequest() {
        if (requestFinalized) return;
        requestFinalized = true;
        _this2.oustandingRequests -= 1;
        if (params.afterRequestRecieved) {
          params.afterRequestRecieved();
        }
      };
      var request = this.getRequestByType(params);
      // console.log('request', request);

      if (params.method !== 'GET') {
        request.set('X-CSRF-Token', this.csrfToken);
      }
      if (this.jwtToken && this.layout.isNative) {
        request.set('Authorization', this.jwtToken);
      } else if (SIMULATE_MOBILE_AUTH) {
        if (this.isBrowser) {
          request.set('Authorization', localStorage.getItem('jwtToken'));
        }
      }
      request.set('DEVICE', this.nativeDevice || 'web');
      if (this.mobileVersionNumber) {
        request.set('MOBILE-VERSION', this.mobileVersionNumber);
      }
      if (this.deviceLanguageId) {
        request.set('DEVICE-LANGUAGE-ID', this.deviceLanguageId);
      }
      if (this.osVersion) {
        request.set('OS-VERSION', this.osVersion);
      }
      if (this.appEnvironment) {
        request.set('ENVIRONMENT', this.appEnvironment);
      }
      var timeZone = this.getDeviceTimeZone();
      if (timeZone) {
        request.set('TIME-ZONE', timeZone);
      }
      if (this.layout.isNative && this.siteId) {
        request.set('SITE-ID', this.siteId);
      }
      if (params.onRequestError) {
        request.on('error', params.onRequestError);
      } else {
        request.on('error', this.handleRequestError.bind(this, params));
      }
      request.on('abort', function () {
        finalizeRequest();
      });
      request.end(function (err, res) {
        finalizeRequest();
        // console.log('res', res);
        // ServerStore.setConnectionProblem(err && isPresent(err.toString().match('Error: Request has been terminated')));
        if (res) {
          var resp;
          try {
            resp = _this2.toCamel(JSON.parse(res.text));
          } catch (_unused2) {
            console.warn('error parsing JSON for URL:', params.url);
            if (params.onRequestError) {
              params.onRequestError(new Error('The server returned an invalid response.'));
            }
          }
          // console.log('after', resp)
          if (resp) {
            if (_this2.layout.isNative && LOG_REACT_NATIVE_REQUESTS && __DEV__) {
              console.log(params.method, params.url);
            }
            if (resp.failure && resp.message) {
              if (params.failureCallback) {
                params.failureCallback(resp);
              }
              _server_store["default"].setErrorMessage(resp.message);
            } else {
              if (params.successCallback) {
                if (resp['csrfToken']) {
                  _this2.csrfToken = resp['csrfToken'];
                }
                params.successCallback(resp);
              }
              _server_store["default"].setSuccessMessage(resp.message);
            }
          }
        }
      });
      return request;
    }
  }, {
    key: "put",
    value: function put(params) {
      return this.ajax((0, _lodash.merge)(params, {
        method: 'PUT'
      }));
    }
  }, {
    key: "post",
    value: function post(params) {
      return this.ajax((0, _lodash.merge)(params, {
        method: 'POST'
      }));
    }
  }, {
    key: "multipartPost",
    value: function multipartPost(params) {
      return this.ajax((0, _lodash.merge)(params, {
        method: 'MULTIPART_POST'
      }));
    }
  }, {
    key: "multipartPostPromise",
    value: function multipartPostPromise(params) {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        _this3.ajax((0, _lodash.merge)(params, {
          method: 'MULTIPART_POST',
          successCallback: resolve,
          failureCallback: reject,
          onRequestError: reject
        }));
      });
    }
  }, {
    key: "get",
    value: function get(params) {
      return this.ajax((0, _lodash.merge)(params, {
        method: 'GET'
      }));
    }
  }, {
    key: "destroy",
    value: function destroy(params) {
      return this.ajax((0, _lodash.merge)(params, {
        method: 'DELETE'
      }));
    }
  }, {
    key: "toCamel",
    value: function toCamel(data) {
      if ((0, _lodash.isArray)(data)) {
        return data.map(function (item) {
          return (0, _normalizeObject["default"])(item, 'camel');
        });
      }
      return (0, _normalizeObject["default"])(data, 'camel');
    }
  }, {
    key: "toUnderscore",
    value: function toUnderscore(data) {
      return (0, _normalizeObject["default"])(data, 'snake');
    }
  }, {
    key: "getRequestByType",
    value: function getRequestByType(params) {
      if (this.layout.isNative && __DEV__) {
        params['url'] = "".concat(this.devApiPath || 'https://www.seedlang.com').concat(params['url']);
      } else if (this.layout.isNative) {
        params.url = "https://www.seedlang.com".concat(params.url);
      }
      switch (params.method) {
        case 'MULTIPART_POST':
          {
            var request = _superagent["default"].post(params.url).timeout(120000).query(params.queryStrings).send(params.data.data);
            if (params.progressCallback) {
              request.on('progress', params.progressCallback);
            }
            return request;
          }
        case 'GET':
          return _superagent["default"].get(params.url).timeout(params.timeout || 20000).query(params.queryStrings).type('json');
        case 'POST':
          return _superagent["default"].post(params.url).timeout(params.timeout || 20000).query(params.queryStrings).send(this.toUnderscore(params.data)).type('json');
        case 'PUT':
          return _superagent["default"].put(params.url).timeout(params.timeout || 20000).query(params.queryStrings).send(this.toUnderscore(params.data)).type('json');
        case 'DELETE':
          return _superagent["default"]["delete"](params.url).timeout(20000).query(params.queryStrings).type('json');
        default:
          return null;
      }
    }
  }, {
    key: "csrfToken",
    value: function csrfToken() {
      if (!this.layout.isNative) {
        var el = document.head.querySelector('[name=\'csrf-token\']');
        return el ? el.content : null;
      }
    }
  }, {
    key: "handleRequestError",
    value: function handleRequestError(params) {
      if (params.method === 'GET') return;
      _server_store["default"].setUserFriendlyErrorMessage(GENERIC_USER_ERROR_MESSAGE);
    }
  }]);
}(), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "oustandingRequests", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "csrfToken", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "jwtToken", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "mobileVersionNumber", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "osVersion", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "nativeDevice", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "deviceLanguageId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "siteId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "appEnvironment", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isBrowser", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  }
}), _descriptor1 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "devApiPath", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return undefined;
  }
}), _class);
var _default = exports["default"] = new Api();